import { Form } from "@components";
import { Box, Grid, Button } from "@material-ui/core";
import React from "react";
import { Actions, Header, Section } from "../../../../components";
import { useRequestContext } from "../../../../context";
import { AddSystemModal } from "./add-system-modal";
import { Filters } from "./filters";
import { messages } from "./messages";
import { Options } from "./options";
import { init, reducer } from "./state";
import { Application } from "@store";

export const SelectSystems: React.FC = () => {
  const [requestContextState, requestContextDispatch] = useRequestContext();
  const [localState, localDispatch] = React.useReducer(reducer, {}, init);
  const active = React.useMemo(() => {
    const { name, view } = requestContextState.step;

    return name === "system-details" && view === "select-systems";
  }, [requestContextState.step]);

  React.useEffect(() => {
    requestContextDispatch({
      type: "set-message",
      message: requestContextState.values.systems.length
        ? messages.system_addedd
        : messages.default,
    });
  }, [requestContextState.values.systems.length, requestContextDispatch]);

  // function test() {
  //   console.log("systems: " + requestContextState.values.systems.length);
  // }

  // function logDets(application: Application) {
  //   console.log("===================APP DETAILS===================");
  //   console.log("app id: " + application.id);
  //   console.log("app name: " + application.name);
  //   console.log("app host: " + application.host);
  //   console.log("app type: " + application.type);
  //   console.log("app accessDetailNote: " + application.accessDetailNote);
  //   console.log("app additionalForm: " + application.additionalForm);
  //   console.log("app categoryId: " + application.categoryId);
  //   console.log("app systemTypeId: " + application.systemTypeId);
  //   console.log("app uamNote: " + application.uamNote);
  //   console.log("app formTemplate: " + application.formTemplate);
  //   console.log("app formTemplate2: " + application.formTemplate2);
  //   console.log("app categoryType: " + application.categoryType);
  //   console.log("app metadata: " + application.metadata);
  //   console.log("app mobileAttestation: " + application.mobileAttestation);
  //   console.log("app singleRequest: " + application.singleRequest);
  //   console.log("app revokeNeededForm: " + application.revokeNeededForm);
  //   console.log("app manual: " + application.manual);
  //   console.log("app lz: " + application.lz);
  // }

  return (
    <Section active={active}>
      <Grid container spacing={2} component={Box} pb={2}>
        <Grid item xs={9}>
          <Header fixed title="System Details">
            <Form>
              <Form.Searchbox
                name="search"
                onChange={React.useCallback((name: "search", value: string) => {
                  localDispatch({
                    type: value ? "add-filter" : "remove-filter",
                    name,
                    value,
                  });
                }, [])}
                placeholder="Search"
                size={12}
                value={localState.filters.search}
              />
            </Form>
          </Header>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        component={Box}
        flexGrow={1}
        overflow="hidden"
      >
        <Grid item xs={9} component={Box} display="flex" height="100%">
          <Options
            filters={localState.filters}
            onSelect={(application) => {
              // logDets(application);
              if (
                application.singleRequest &&
                requestContextState.values.users.length > 1
              ) {
                requestContextDispatch({
                  type: "set-message",
                  message: messages.single_user_only_app.replace(
                    "[[APPLICATION_NAME]]",
                    application.name
                  ),
                  error: new Error(messages.single_user_only_app),
                });
              } else {
                localDispatch({
                  type: "open-add-system-accesses-modal",
                  system: requestContextState.values.systems.find(
                    (system) =>
                      system.application.id === application.id &&
                      system.application.manual === application.manual &&
                      system.application.lz === application.lz
                  ) || {
                    application,
                    accesses: [],
                  },
                });
              }
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <Filters
            current={localState.filters}
            onChange={React.useCallback(
              (name: "host" | "type", value: string, checked: boolean) => {
                localDispatch({
                  type: checked ? "add-filter" : "remove-filter",
                  name,
                  value,
                });
              },
              []
            )}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} component={Box} pt={2}>
        <Grid item xs={9}>
          <Actions>
            <Actions.Cancel />
            <Actions.Previous
              onClick={React.useCallback(() => {
                requestContextDispatch({
                  type: "set-step",
                  name: "user-information",
                  view:
                    requestContextState.values.target === "SELF" ||
                    !requestContextState.values.users.length
                      ? "select-target"
                      : "users-list",
                });
              }, [
                requestContextDispatch,
                requestContextState.values.target,
                requestContextState.values.users,
              ])}
            />
            <Actions.Next
              disabled={!requestContextState.values.systems.length}
              onClick={React.useCallback(() => {
                requestContextDispatch({
                  type: "set-step",
                  name: "system-details",
                  view: "systems-list",
                });
              }, [requestContextDispatch])}
            />
          </Actions>
        </Grid>
      </Grid>
      <AddSystemModal
        system={localState.add_system_accesses_modal.system}
        onClose={React.useCallback(() => {
          localDispatch({
            type: "close-add-system-accesses-modal",
          });
        }, [])}
        open={localState.add_system_accesses_modal.open}
      />
    </Section>
  );
};
